var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content-header"},[_c('h2',[_vm._v("广告投放")])]),_c('div',{staticClass:"content-con"},[_c('img',{staticStyle:{"width":"100%","margin-top":"20px"},attrs:{"src":require("../../assets/images/beb6de6d-3e29-4031-844a-84187e57ba97.png"),"alt":""}})])])
}]

export { render, staticRenderFns }